import React from 'react';
import PropTypes from 'prop-types';
import { SizeMe } from 'react-sizeme';
import { withTheme } from 'react-jss';
import DescriptionList from '../DescriptionList';

const Context = React.createContext({
    shouldBreak: false
});

const DescriptionListResponsive = withTheme(({ children, breakpoint, theme: { theme }, ...rest }) => {
    const LAYOUT_CHANGE_BP = breakpoint || theme.screens.md;
    return (
        <SizeMe>
            {({ size }) => (
                <Context.Provider
                    value={{
                        shouldBreak: size.width < LAYOUT_CHANGE_BP
                    }}
                >
                    <DescriptionList {...rest}>{children}</DescriptionList>
                </Context.Provider>
            )}
        </SizeMe>
    );
});

DescriptionListResponsive.Row = ({ children, ...rest }) => (
    <Context.Consumer>
        {({ shouldBreak }) => (
            <DescriptionList.Row {...rest} column={shouldBreak}>
                {children}
            </DescriptionList.Row>
        )}
    </Context.Consumer>
);

DescriptionListResponsive.Term = ({ children, ...rest }) => (
    <Context.Consumer>
        {({ shouldBreak }) => (
            <DescriptionList.Term bold={shouldBreak} {...rest}>
                {children}
            </DescriptionList.Term>
        )}
    </Context.Consumer>
);

DescriptionListResponsive.Header = DescriptionList.Header;
DescriptionListResponsive.Definition = DescriptionList.Definition;
DescriptionListResponsive.propTypes = {
    /** Custom breakpoint for layout change, defaults to theme.screens.md */
    breakpoint: PropTypes.number
};
export default DescriptionListResponsive;
